import React, { memo, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import FileUpload from './file-upload';
import { resetPurchaseEmailVerificationCreditsResponse ,
  resetGetCreditsTransactionStatusRequest,
  resetPurchaseCreditsRequest,
} from '../../settings/components/billing-subscription/billing-subscription-slice';
import { getContactFieldsRequest } from '../../sequence/extra-actions';
import { FileUploadProps } from './type';
import {
  getEmailVerificationCreditsRequest,
  purchaseEmailVerificationCreditsRequest,
  getCreditsTransactionStatusRequest,
} from '../../settings/components/billing-subscription/extra-actions';

import { uploadedFileCsvRequest } from '../extra-action';
import {
  AddEmailFromCSVRequestPayload,
  GetUploadedFilePayload,
} from '../types';
import {
  resetUploadedFileCsvRequest,
  searchPaginationState,
} from '../email-verifier-slice';
import { enableBulkActionRequestPolling } from '../../home/home-slice';
import { PurchaseEmailVerificationCreditsRequest } from '../../settings/components/billing-subscription/types';
import { RootState } from '../../../store/root-reducer';
import { CreditsTransactionStatusRequest } from '../../settings/components/billing-subscription/types/purchase-credits';

const FileUploadContainer = memo((props: FileUploadProps) => {
  const contactField = useSelector(
    (state: RootState) => state?.sequence?.contactFields,
  );
  const emailVerifyCredits = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription?.getEmailVerificationCreditsResponse
        ?.creditsAvailable,
  );

  const uploadedFileCsvRequestStatus = useSelector(
    (state: RootState) => state?.emailVerifier?.uploadedFileCsvRequest?.status,
  );

  // Credits transaction polling
  const getCreditsTransactionStatusRequestStatus = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription?.getCreditsTransactionStatusRequest?.status,
  );
  const getCreditsTransactionStatusResponse = useSelector(
    (state: RootState) =>
      state?.billingAndSubscription?.getCreditsTransactionStatusResponse,
  );

  const dispatch = useDispatch();

  const resetPurchaseEmailVerificationCreditsResponses = useCallback(() => {
    dispatch(resetPurchaseEmailVerificationCreditsResponse());
  }, [dispatch]);

  const getContactFieldsRequests = useCallback(() => {
    dispatch(getContactFieldsRequest());
  }, [dispatch]);

  const getEmailVerificationCreditsRequests = useCallback(() => {
    dispatch(getEmailVerificationCreditsRequest());
  }, [dispatch]);

  const uploadedFileCsvRequests = useCallback(
    (payload: AddEmailFromCSVRequestPayload) => {
      dispatch(uploadedFileCsvRequest(payload));
    },
    [dispatch],
  );

  const resetUploadedFileCsvRequests = useCallback(() => {
    dispatch(resetUploadedFileCsvRequest());
  }, [dispatch]);

  const enableBulkActionRequestPollings = useCallback(() => {
    dispatch(enableBulkActionRequestPolling());
  }, [dispatch]);

  const purchaseEmailVerificationCreditsRequests = useCallback(
    (payload: PurchaseEmailVerificationCreditsRequest) => {
      dispatch(purchaseEmailVerificationCreditsRequest(payload));
    },
    [dispatch],
  );

  const setSearchPagination = useCallback((payload: GetUploadedFilePayload) => {
    dispatch(searchPaginationState(payload));
  }, []);

  const sendGetCreditsTransactionStatusRequest = useCallback(
    (payload: CreditsTransactionStatusRequest) => {
      dispatch(getCreditsTransactionStatusRequest(payload));
    },
    [dispatch],
  );

  const resetGetCreditsTransactionStatusRequestCb = useCallback(() => {
    dispatch(resetGetCreditsTransactionStatusRequest());
  }, [dispatch]);

  const resetPurchaseCreditsRequestCb = useCallback(() => {
    dispatch(resetPurchaseCreditsRequest());
  }, [dispatch]);

  return (
    <FileUpload
      {...props}
      contactField={contactField}
      emailVerifyCredits={emailVerifyCredits}
      uploadedFileCsvRequestStatus={uploadedFileCsvRequestStatus}
      resetPurchaseEmailVerificationCreditsResponses={
        resetPurchaseEmailVerificationCreditsResponses
      }
      getContactFieldsRequests={getContactFieldsRequests}
      getEmailVerificationCreditsRequests={getEmailVerificationCreditsRequests}
      uploadedFileCsvRequests={uploadedFileCsvRequests}
      resetUploadedFileCsvRequests={resetUploadedFileCsvRequests}
      enableBulkActionRequestPollings={enableBulkActionRequestPollings}
      purchaseEmailVerificationCreditsRequests={
        purchaseEmailVerificationCreditsRequests
      }
      setSearchPagination={setSearchPagination}
      getCreditsTransactionStatusRequestStatus={
        getCreditsTransactionStatusRequestStatus
      }
      getCreditsTransactionStatusResponse={getCreditsTransactionStatusResponse}
      sendGetCreditsTransactionStatusRequest={
        sendGetCreditsTransactionStatusRequest
      }
      resetGetCreditsTransactionStatusRequest={
        resetGetCreditsTransactionStatusRequestCb
      }
      resetPurchaseCreditsRequest={resetPurchaseCreditsRequestCb}
    />
  );
});

export default FileUploadContainer;
